import React from 'react';
import { formatDayShort } from '../../utils/format';

/** Scelta giorno con conteggio orari liberi (scroll orizzontale su mobile). */
export function DayPicker({ days = [], selectedDate, onSelect, className = '' }) {
  return (
    <div
      className={`flex gap-2 overflow-x-auto pb-2 ${className}`}
      role="listbox"
      aria-label="Giorni disponibili"
    >
      {days.map((d) => {
        const date = d.date || d;
        const count = d.count ?? d.slotCount;
        const selected = String(selectedDate) === String(date);
        return (
          <button
            key={String(date)}
            type="button"
            role="option"
            aria-selected={selected}
            className={[
              'min-h-touch shrink-0 rounded-vc border px-3 py-2 text-left text-vc-sm',
              selected ? 'border-vc-primary bg-vc-primary-light text-vc-primary' : 'border-vc-line bg-vc-surface text-vc-ink'
            ].join(' ')}
            onClick={() => onSelect?.(date)}
          >
            <span className="block font-medium capitalize">{formatDayShort(date)}</span>
            {count != null && (
              <span className="block text-vc-xs text-vc-ink-3">{count} orari</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
